/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import { Chip } from "@mui/material";
import {
	GetPermissionColorConfig,
	GetPermissionLabel,
	GetPermissionSortOrder,
} from "lib/permissions/PermissionUtils";

interface plantPermissionChipProps {
	objectName: string;
	permissionCode?: string;
}

// Re-export for backward compatibility
export { GetPermissionSortOrder };

export function PlantPermissionChip({
	objectName,
	permissionCode,
}: plantPermissionChipProps) {
	const colorConfig = GetPermissionColorConfig(permissionCode);
	const label = GetPermissionLabel(objectName, permissionCode);

	return (
		<Chip
			label={label}
			size="small"
			sx={{
				fontWeight: 500,
				backgroundColor: colorConfig.backgroundColor,
				color: colorConfig.color,
				minWidth: "100px",
				justifyContent: "center",
				"&:hover": {
					opacity: 0.9,
				},
			}}
		/>
	);
}

